interface ProgressBarProps {
    current: number;
    max: number;
    isPro?: boolean;
}

export default function ProgressBar({ current, max, isPro = false }: ProgressBarProps) {
    const percentage = Math.min(100, (current / max) * 100);
    const remaining = Math.max(0, max - current);

    if (isPro) {
        return (
            <div className="card mb-4">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">Scans this month</span>
                        <span className="bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">PRO</span>
                    </div>
                    <span className="text-lg font-bold text-primary-600">Unlimited</span>
                </div>
            </div>
        );
    }

    return (
        <div className="card mb-4">
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700">Scans this month</span>
                <span className="text-sm font-bold text-gray-900">{current} / {max}</span>
            </div>
            <div className="progress-bar">
                <div
                    className="progress-fill"
                    style={{ width: `${percentage}%` }}
                />
            </div>
            <p className="text-xs text-gray-500 mt-2">
                {remaining > 0 ? `${remaining} scans remaining` : 'Limit reached'}
            </p>
        </div>
    );
}
